import { useAuth } from 'src/util/authenticationProvider';
import { useEffect, useState } from 'react';
import * as React from 'react';
import axios from 'axios';
import { Alert, Box, Button, Checkbox, Container, CssBaseline, FormControlLabel, Grid, List, ListItemButton, ListItemIcon, ListItemText, Paper, TextField, ThemeProvider, useTheme } from '@mui/material';
import { t } from 'i18next';
import { PrizeDto, Lottery } from 'src/util/types';
import config from 'src/config';

function not(a: readonly string[], b: readonly string[]) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a: readonly string[], b: readonly string[]) {
  return a.filter((value) => b.indexOf(value) !== -1);
}


export default function LotteryEdit(props: Lottery) {
  const authContext = useAuth();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [checked, setChecked] = React.useState<readonly string[]>([]);
  const [prizeList, setPrizeList] = useState<readonly PrizeDto[]>([]);
  const [left, setLeft] = React.useState<readonly string[]>([]);
  const [right, setRight] = React.useState<readonly string[]>([]);
  const [lotteries, setLotteries] = useState<Lottery[]>([]);
  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);
  
  let prizeArray = []
  const getPrizeList = async () => {
    await axios.get(config.apiUrl + "/api/prize/all", {
      headers: {
        "Authorization": "Bearer " + authContext.token
      }
    }).then((pList) => {
      setPrizeList(pList.data.content)
      pList.data.content.map(p => {
        prizeArray = prizeArray.concat(p.id.toString());
      }
      )
      setLeft(prizeArray);
      initialCheckedRight();
    })
  }

  const getLotteries = async () => {
    await axios.get(config.apiUrl + "/api/lottery/all", {
      headers: {
        "Authorization": "Bearer " + authContext.token
      }
    }).then((pList) => {
      setLotteries(pList.data.content);
    }
    )
  }


  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (items: readonly string[]) => (
    <Paper sx={{ width: 200, height: 230, overflow: 'auto' }}>
      <List dense component="div" role="list">
        {items.map((value: string, key) => {
          var label = '';
          prizeList.map(prizeItem => {
            if (value.includes(prizeItem.id.toString())) {
              label = prizeItem.description;
            }
          })
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItemButton
              key={value}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={label} />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );


  const handleSubmitData = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');

    const formData = new FormData(event.currentTarget);
    const bodyData = {
      id: props.id,
      startDate: formData.get("startDate") ? formData.get("startDate") : props.startDate,
      endDate: formData.get("endDate") ? formData.get("endDate") : props.endDate,
      name: formData.get("name") ? formData.get("name") : props.name,
      prizes: Object.fromEntries(right.map((v, k) => [k + 1, v]))
    }
    axios.post(config.apiUrl + "/api/lottery/update", bodyData, {
      headers: {
        'Authorization': 'Bearer ' + authContext.token
      }
    })
      .then(() => {
        setSuccess('Creation successful.');
      })
      .catch(() => {
        setError('Connection to Server failed.')
      })
  }

  const initialCheckedRight = () => {
    let includedPrizes = [];
    const currentPrizes: Map<number, PrizeDto> = props.prizes
    Object.entries(props.prizes).map(([key, val]) => {
      includedPrizes = includedPrizes.concat(val.id.toString());
      setLeft(not(left, val.id.toString()));
      setChecked(not(checked, leftChecked));
    })
    setRight(includedPrizes);
  };

  useEffect(() => {
    getPrizeList();
    getLotteries();

  }, [])


  return (
    <>
      <ThemeProvider theme={useTheme}>
        <Container component="main" maxWidth="lg">
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box component="form" onSubmit={handleSubmitData} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                fullWidth
                id="name"
                label="Name"
                name="name"
                defaultValue={props.name}
                autoComplete="name"
                autoFocus
              />
              <TextField
                margin="normal"
                type="datetime-local"
                required
                fullWidth
                id="startDate"
                name="startDate"
                defaultValue={props.startDate}
              />
              <TextField
                margin="normal"
                type="datetime-local"
                required
                fullWidth
                name="endDate"
                id="endDate"
                defaultValue={props.endDate}
              />

              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item>{customList(left)}</Grid>
                <Grid item>
                  <Grid container direction="column" alignItems="center">
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedRight}
                      disabled={leftChecked.length === 0}
                      aria-label="move selected right"
                    >
                      ADD to Lottery &gt;
                    </Button>
                    <Button
                      sx={{ my: 0.5 }}
                      variant="outlined"
                      size="small"
                      onClick={handleCheckedLeft}
                      disabled={rightChecked.length === 0}
                      aria-label="move selected left"
                    >
                      &lt; Remove from lottery
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>{customList(right)}</Grid>
              </Grid>


              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Speichern
              </Button>
            </Box>
            {error ? <Alert severity="error">{error}</Alert> : ''}
            {success ? <Alert severity="success">{success}</Alert> : ''}
          </Box>
        </Container>
      </ThemeProvider>
    </>
  );
}